import { formatPrice } from "utils/helpers/functions/formatPrice";
import { useSettings } from "context/SettingsContext";

type ProductOperPriceProps = {
    operation: any;
    /** У об'єкті — ціна продажу; у складі (за замовч.) — курс грн */
    showSalePrice?: boolean;
    onSaleClick?: (price: number, priceRate: number) => void;
};

const ProductOperPrice = ({operation, showSalePrice = false, onSaleClick}: ProductOperPriceProps) => {
    const { localSettings } = useSettings();
    const isUahMode = (Number(localSettings?.RATE?.current ?? 1) || 1) === 1;

    const price = formatPrice(operation?.operPrice);
    const priceSale = formatPrice(operation?.operPriceSale);
    const priceRate = formatPrice(operation?.operPriceRate);
    const priceSaleRate = formatPrice(operation?.operPriceSaleRate);

    return (<>
        <h6 className="mb-1">{isUahMode ? `₴ ${price}` : `$ ${price}`}</h6>
        {showSalePrice ? (
            <p
                className={`f-12 mb-0 text-truncate text-primary${onSaleClick ? ' cursor-pointer' : ''}`}
                onClick={() => {
                    if (onSaleClick) onSaleClick(operation?.operPriceSale, operation?.operPriceSaleRate);
                }}
                title={isUahMode ? undefined : `₴ ${priceSaleRate}`}
            >
                {isUahMode ? `₴ ${priceSale}` : `$ ${priceSale}`}
            </p>
        ) : (
            !isUahMode && (
                <p className="text-muted f-12 mb-0 my-1">₴ {priceRate}</p>
            )
        )}
    </>)
}
 
export default ProductOperPrice;
